module.exports = __webpack_public_path__ + "media/images/ln/horoscope_11-9542add0ee818ffa38420b6a550d76eb.png";